/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatMoney, FlexRow, FlexCol, TextBlock, Stack } from 'sarsaparilla';

export default class CostsTable extends PureComponent {
    static propTypes = {
        subtotal: PropTypes.number,
        total: PropTypes.number,
        reservations: PropTypes.any,
        noLineItemsText: PropTypes.string,
    };

    static defaultProps = {
        reservations: [],
        noLineItemsText: 'Please configure your reservation.',
    };

    buildCartLineItemRow = (desc, amt) => (
        <FlexRow className="rec-order-summary-item-price" key={desc}>
            <FlexCol xs={6} md={8} xl={6}>
                {desc}
            </FlexCol>
            <FlexCol xs={6} md={4} xl={6} alignSelf="end" className="pr-3">
                <TextBlock textAlign="right">{formatMoney(amt)}</TextBlock>
            </FlexCol>
        </FlexRow>
    );

    renderLine = (line) => {
        // calc_qty is either
        // 1. state value +/- by user on the Order Details page (e.g. Mattamuskeet permits) OR
        // 2. cart line item quantity if there is no Total Group Member section visible.
        const { description, unit_price, calc_qty } = line;

        return this.buildCartLineItemRow(
            description + ' x ' + calc_qty,
            unit_price * calc_qty
        );
    };

    renderSubtotalCost = (line) => {
        const { description, subtotal } = line;

        if (!subtotal) return null;

        return this.buildCartLineItemRow(description, subtotal);
    };

    renderTotalCost() {
        return (
            <div className="rec-order-summary-total per-os-total">
                <FlexRow>
                    <FlexCol className="rec-price-label">Total Cost</FlexCol>
                    <FlexCol className="rec-price-value">
                        <strong>{formatMoney(this.props.total)}</strong>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }

    render() {
        const { subtotal, reservations, noLineItemsText } = this.props;
        return reservations.map(
            ({ reservation_id, cart_line_items: lineItems = [] }, index) => (
                <Stack space="sm" key={reservation_id}>
                    {lineItems.length ? (
                        lineItems.map(this.renderLine)
                    ) : (
                        <p>{noLineItemsText}</p>
                    )}

                    {index === reservations.length - 1 && (
                        <>
                            {this.renderSubtotalCost({
                                description: 'Subtotal',
                                subtotal,
                            })}
                            {this.renderTotalCost()}
                        </>
                    )}
                </Stack>
            )
        );
    }
}
